import { useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { MessageCircle } from "lucide-react";
import { SupportForm } from "./SupportForm";

export default function SupportButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        className="fixed bottom-6 right-6 h-14 px-6 shadow-lg"
        variant="contained"
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          height: 56,
          px: 3,
          bgcolor: 'primary.main',
          '&:hover': {
            bgcolor: 'primary.dark',
          },
          boxShadow: 3,
          zIndex: 1000,
        }}
      >
        <MessageCircle style={{ marginRight: 8, width: 20, height: 20 }} />
        Support & Feedback
      </Button>
      
      <Dialog 
        open={open} 
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: '90vh',
            overflow: 'auto',
          },
        }}
      >
        <DialogTitle sx={{ color: 'primary.main', fontWeight: 600 }}>
          Support & Feedback
        </DialogTitle>
        <DialogContent>
          <SupportForm onClose={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
}
